<div class="container my-auto">
    <div class="copyright text-center my-auto">
        <span>Copyright &copy; Afrikpay 2019</span>
    </div>
</div>
